import { render, staticRenderFns } from "./CatalogFilterMobileSections.vue?vue&type=template&id=11b33ebf&scoped=true"
import script from "./CatalogFilterMobileSections.vue?vue&type=script&lang=js"
export * from "./CatalogFilterMobileSections.vue?vue&type=script&lang=js"
import style0 from "./CatalogFilterMobileSections.vue?vue&type=style&index=0&id=11b33ebf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b33ebf",
  null
  
)

/* custom blocks */
import block0 from "./translations?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fdata%2Fwww%2Fsrc%2Fcomponents%2F01-atoms%2Fcatalog-filter-mobile-sections%2FCatalogFilterMobileSections.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports